// src/components/TokenUtilitySection.tsx
import SectionHeading from "./SectionHeading";

const UTILITIES = [
  { icon: "🎮", label: "Play-to-Earn",   desc: "Earn MEE by playing games and completing missions on-chain" },
  { icon: "🏅", label: "Badge NFTs",      desc: "Mint ERC721 badge NFTs that grant XP bonuses and exclusive perks" },
  { icon: "💰", label: "Staking",         desc: "Stake MEE tokens with 21 validators and earn passive rewards" },
  { icon: "🗳️", label: "Governance",      desc: "Vote on protocol upgrades and ecosystem proposals (coming soon)" },
  { icon: "🔗", label: "Bridge & Swap",   desc: "Bridge MEE across BSC, Polygon, Arbitrum and more chains" },
  { icon: "⚡", label: "Gas Fee Utility", desc: "Use MEE to pay transaction fees on the MeeChain network" },
];

const TOKEN_STATS = [
  { label: "Total Supply",  val: "1,000,000,000", unit: "MEE" },
  { label: "Circulating",   val: "320,421,880",   unit: "MEE" },
  { label: "Staked",        val: "32%",           unit: "" },
  { label: "Chain ID",      val: "13390",         unit: "" },
];

export default function TokenUtilitySection() {
  return (
    <section style={{ padding: "64px 48px", position: "relative", zIndex: 1, background: "rgba(124,58,237,.03)" }}>
      <SectionHeading eyebrow="Token" title="MEE Token" accent="Utility" desc="One token powering the entire MeeChain ecosystem." center />

      {/* Stats row */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 40 }}>
        {TOKEN_STATS.map(s => (
          <div key={s.label} style={{
            background: "var(--bg2)", border: "1px solid rgba(124,58,237,.25)",
            borderRadius: 12, padding: "20px 24px", textAlign: "center",
          }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "var(--muted)", letterSpacing: ".1em", textTransform: "uppercase", marginBottom: 6 }}>{s.label}</div>
            <div style={{ fontSize: 24, fontWeight: 700, fontFamily: "var(--display)", color: "#fff" }}>
              {s.val} <span style={{ fontSize: 13, color: "var(--purple4)" }}>{s.unit}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Utilities grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
        {UTILITIES.map(u => (
          <div key={u.label} style={{
            display: "flex", alignItems: "flex-start", gap: 14,
            background: "var(--bg2)", border: "1px solid rgba(124,58,237,.2)",
            borderRadius: 10, padding: "16px 18px",
          }}>
            <div style={{
              width: 40, height: 40, borderRadius: 10, flexShrink: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 18, background: "rgba(124,58,237,.15)", border: "1px solid rgba(124,58,237,.3)",
            }}>{u.icon}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#fff", marginBottom: 4 }}>{u.label}</div>
              <div style={{ fontSize: 12, color: "var(--muted)", lineHeight: 1.5 }}>{u.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
